//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Button } from "react-bootstrap";
import { ErrorHandlerActions } from "./errorHadlerActions";
import ErrorAlertMessage from "../common/alertMessages/errorAlertMessage";

const ErrorHandler = ({ resetErrorBoundary }) => {
    const navigate = useNavigate();
    const [errorHandlerJson, setErrorHandlerJson] = useState({});

    const [errorAlert, setErrorAlert] = useState({
        showAlert: false
    })

    const showErrorModal = () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        refErrorMessageAlert.showAlert = false;
        setErrorAlert(refErrorMessageAlert)
    }

    const fetchErrorHandlerJson = async () => {
        let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
        await ErrorHandlerActions.GetErrorHandlerJSON().then(
            (res) => {
                if (res.status === 200 || res.status === 204) {
                    setErrorHandlerJson(JSON.parse(JSON.stringify(res?.data)));
                }
                else {
                    refErrorMessageAlert.showAlert = true;
                    setErrorAlert(refErrorMessageAlert);
                    window.scrollTo(0, 0);
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }
    const fetchErrorHandlerLabel = (key) => {
        let refJsonContent = JSON.parse(JSON.stringify(errorHandlerJson));
        let label = "";

        refJsonContent?.Properties?.Labels?.map((x) => {
            if (x.Key === key) {
                label = x.Phrase;
            }
        });

        return label;
    };

    useEffect(() => {
        fetchErrorHandlerJson()
    }, []);

    return (
        <div className="text-center">
            {errorAlert?.showAlert &&
                <ErrorAlertMessage alertMessage="AllPages.ErrorAlertMessage" showAlert={showErrorModal} />
            }
            <p className="m-5 h1">{fetchErrorHandlerLabel("ErrorHandler.ErrorMessage")}</p>
            <Button variant="primary" size="lg" onClick={() => {
                resetErrorBoundary()
                navigate("/dashboard")
            }}>
                {fetchErrorHandlerLabel('ErrorHandler.ReturnToDashboard')}
            </Button>

        </div>
    );
};

export default ErrorHandler;
